import { render, staticRenderFns } from "./PersonalMenu.vue?vue&type=template&id=9b68cdfa&scoped=true&"
import script from "./PersonalMenu.vue?vue&type=script&lang=js&"
export * from "./PersonalMenu.vue?vue&type=script&lang=js&"
import style0 from "./PersonalMenu.vue?vue&type=style&index=0&id=9b68cdfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b68cdfa",
  null
  
)

export default component.exports